import axios from '../http'

function add(data) {
    return axios.post('/basedata/customer/add', data);
}

function del(data) {
    return axios.post('/basedata/customer/del', data);
}

function update(data) {
    return axios.post('/basedata/customer/update', data);
}

function query(data) {
    return axios.post('/basedata/customer/query', data);
}


function get(id) {
    return axios.get('/basedata/customer/get?id=' + id);
}

function getOptions() {
    return axios.get('/basedata/customer/getOptions');
}

function findOptionsByDistributorId(distributorId) {
    return axios.get('/basedata/customer/findOptionsByDistributorId?distributorId=' + distributorId);
}

export default {
    add,
    del,
    update,
    query,
    get,
    getOptions,
    findOptionsByDistributorId
}